<template>
	<div v-loading="loading" class="base_scroll_page">
		<!-- 滚动区域 -->
		<div class="b_scroller">
			<div class="base_showTable">
				<table>
					<template v-for="v in list">
						<tr :key="v.flag">
							<td style="width: 50%;">{{ v.name }}</td>
							<td style="width: 50%;">
								<el-input-number v-if="v.flag != 'isOpenBlackHouse'" v-model="v.val" :min="1" size="small"></el-input-number>
								<el-switch v-if="v.flag == 'isOpenBlackHouse'" v-model="v.val"></el-switch>
								<template v-if="v.unit">（{{ v.unit }}）</template>
							</td>
						</tr>
					</template>
					
				</table>
			</div>
			
			<!-- 页码 -->
			<div style="margin-top: 20px;">
				<el-button type="primary" @click="handleUpdateClick">修改</el-button>
			</div>
			<!-- 页码 end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="account"
						label="账号"
					>
					</el-table-column>
					<el-table-column
						prop="num"
						label="上限次数"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="400"
					>
						<template slot-scope="scope">
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
		</div>
		<!-- 滚动区域 end -->
		
		<!-- 修改弹出框 -->
		<Popup
			v-model="update_display"
			title="提示"
			@confirmClick="handleUpdatePopupConfirmClick"
		>
			<div style="padding: 15px;">
				<p style="color: #5f6468;line-height: 24px;">您确认要修改吗？</p>
			</div>
		</Popup>
		<!-- 修改弹出框 end -->
		
		<!-- 删除弹出框 -->
		<Popup
			v-model="delete_display"
			title="提示"
			@confirmClick="handleDeletePopupConfirmClick"
		>
			<div style="padding: 15px;">
				<p style="color: #5f6468;line-height: 24px;">您确认要删除该用户吗？</p>
			</div>
		</Popup>
		<!-- 删除弹出框 end -->
	</div>
</template>

<script>
	import Api from '../../../../api/index.js'
	
	export default {
		mounted () {
			this.getData();
		},
		data () {
			return {
				loading: false,
				list: [],
				tableData: [],
				delete_account: '',
				update_display: false,
				delete_display: false
			}
		},
		methods: {
			/********************************* @Events *********************************/
			// 点击修改
			handleUpdateClick () {
				this.update_display = true;
			},
			// 点击修改弹出框确认按钮
			handleUpdatePopupConfirmClick () {
				const that = this;
				var blackHouseTime = null,
					num = null,
					time = null,
					isOpenBlackHouse = null;
				this.list.forEach(v => {
					v.flag == 'blackHouseTime' && (blackHouseTime = v.val);
					v.flag == 'num' && (num = v.val);
					v.flag == 'time' && (time = v.val);
					v.flag == 'isOpenBlackHouse' && (isOpenBlackHouse = v.val ? 1 : 0);
				});
				var requestData = {
					blackHouseTime,
					num,
					time,
					isOpenBlackHouse
				};
				that.loading = true;
				Api.updateIpHouse(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.update_display = false;
						that.$message.success(res.data.message);
						that.getData();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			
			// 点击删除
			handleDeleteClick (obj) {
				this.delete_account = obj.account;
				this.delete_display = true;
			},
			// 点击删除弹框确认按钮
			handleDeletePopupConfirmClick () {
				const that = this;
				that.loading = true;
				var requestData = {
					codes: that.delete_account
				};
				Api.deleteIpConfiner(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.delete_display = false;
						that.$message.success(res.data.message);
						that.watchConfiner();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			
			/********************************* @Function *********************************/
			// 请求数据
			getData () {
				const that = this;
				that.loading = true;
				var requestData = {};
				Api.findIpHouse(requestData).then((res) => {
					if (res.data.success) {
						that.list = [];
						for (var k in res.data.data) {
							k == 'blackHouseTime' 
								&& that.list.push({
									flag: 'blackHouseTime',
									name: '黑屋禁闭时间',
									val: res.data.data[k],
									unit: '秒'
								});
							k == 'num'
								&& that.list.push({
									flag: 'num',
									name: '上限',
									val: res.data.data[k],
									unit: '次'
								});
							k == 'time'
								&& that.list.push({
									flag: 'time',
									name: '频率',
									val: res.data.data[k],
									unit: '秒'
								});
							k == 'isOpenBlackHouse'
								&& that.list.push({
									flag: 'isOpenBlackHouse',
									name: '是否开启小黑屋',
									val: res.data.data[k] == 0 ? false : true,
									unit: ''
								});
						}
						that.watchConfiner();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 查看禁闭人员
			watchConfiner () {
				const that = this;
				that.loading = true;
				var requestData = {};
				Api.findIpConfiner(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.tableData = [];
						res.data.data.forEach(v => {
							that.tableData.push({
								id: v.id,
								account: v.code,
								num: v.num
							});
						});
						that.confiner_display = true;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		}
	}
</script>

<style scoped>
	.back_tools_manage{ position: relative;width: 100%;height: 100%;padding: 15px; }
	.back_tools_manage .scroller{ width: 100%;height: 100%;padding: 15px;background: #fff;overflow-x: hidden;overflow-y: auto; }
</style>
